var _get = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _assertThisInitialized = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
!function (e) {
  var t = e.en = e.en || {};
  t.dictionary = Object.assign(t.dictionary || {}, {
    "Insert media": "Insert media",
    "Media toolbar": "Media toolbar",
    "Media URL": "Media URL",
    "media widget": "media widget",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    "The URL must not be empty.": "The URL must not be empty.",
    "This media URL is not supported.": "This media URL is not supported.",
    "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster."
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function () {
  var e = {
      461: function _(e, t, i) {
        "use strict";

        i.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var r = i(609),
          a = i.n(r)()(function (e) {
            return e[1];
          });
        a.push([e.id, ".ck-content .media{clear:both;margin:.9em 0;display:block;min-width:15em}", ""]);
        var o = a;
      },
      721: function _(e, t, i) {
        "use strict";

        i.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var r = i(609),
          a = i.n(r)()(function (e) {
            return e[1];
          });
        a.push([e.id, '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(var(--ck-spacing-standard)*3);background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', ""]);
        var o = a;
      },
      961: function _(e, t, i) {
        "use strict";

        i.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var r = i(609),
          a = i.n(r)()(function (e) {
            return e[1];
          });
        a.push([e.id, ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", ""]);
        var o = a;
      },
      764: function _(e, t, i) {
        "use strict";

        i.d(t, {
          Z: function Z() {
            return o;
          }
        });
        var r = i(609),
          a = i.n(r)()(function (e) {
            return e[1];
          });
        a.push([e.id, '.ck-vertical-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*0.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-large);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after,[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', ""]);
        var o = a;
      },
      609: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var i = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(i, "}") : i;
            }).join("");
          }, t.i = function (e, i, r) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var a = {};
            if (r) for (var o = 0; o < this.length; o++) {
              var c = this[o][0];
              null != c && (a[c] = !0);
            }
            for (var n = 0; n < e.length; n++) {
              var l = [].concat(e[n]);
              r && a[l[0]] || (i && (l[2] ? l[2] = "".concat(i, " and ").concat(l[2]) : l[2] = i), t.push(l));
            }
          }, t;
        };
      },
      62: function _(e, t, i) {
        "use strict";

        var r,
          a = function a() {
            return void 0 === r && (r = Boolean(window && document && document.all && !window.atob)), r;
          },
          o = function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var i = document.querySelector(t);
                if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
                  i = i.contentDocument.head;
                } catch (e) {
                  i = null;
                }
                e[t] = i;
              }
              return e[t];
            };
          }(),
          c = [];
        function n(e) {
          for (var t = -1, i = 0; i < c.length; i++) if (c[i].identifier === e) {
            t = i;
            break;
          }
          return t;
        }
        function l(e, t) {
          for (var i = {}, r = [], a = 0; a < e.length; a++) {
            var o = e[a],
              l = t.base ? o[0] + t.base : o[0],
              s = i[l] || 0,
              d = "".concat(l, " ").concat(s);
            i[l] = s + 1;
            var u = n(d),
              m = {
                css: o[1],
                media: o[2],
                sourceMap: o[3]
              };
            -1 !== u ? (c[u].references++, c[u].updater(m)) : c.push({
              identifier: d,
              updater: j(m, t),
              references: 1
            }), r.push(d);
          }
          return r;
        }
        function s(e) {
          var t = document.createElement("style"),
            r = e.attributes || {};
          if (void 0 === r.nonce) {
            var a = i.nc;
            a && (r.nonce = a);
          }
          if (Object.keys(r).forEach(function (e) {
            t.setAttribute(e, r[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var c = o(e.insert || "head");
            if (!c) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            c.appendChild(t);
          }
          return t;
        }
        var d,
          u = (d = [], function (e, t) {
            return d[e] = t, d.filter(Boolean).join("\n");
          });
        function m(e, t, i, r) {
          var a = i ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
          if (e.styleSheet) e.styleSheet.cssText = u(t, a);else {
            var o = document.createTextNode(a),
              c = e.childNodes;
            c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(o, c[t]) : e.appendChild(o);
          }
        }
        function M(e, t, i) {
          var r = i.css,
            a = i.media,
            o = i.sourceMap;
          if (a ? e.setAttribute("media", a) : e.removeAttribute("media"), o && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
            for (; e.firstChild;) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(r));
          }
        }
        var g = null,
          N = 0;
        function j(e, t) {
          var i, r, a;
          if (t.singleton) {
            var o = N++;
            i = g || (g = s(t)), r = m.bind(null, i, o, !1), a = m.bind(null, i, o, !0);
          } else i = s(t), r = M.bind(null, i, t), a = function a() {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(i);
          };
          return r(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              r(e = t);
            } else a();
          };
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = a());
          var i = l(e = e || [], t);
          return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var r = 0; r < i.length; r++) {
                var a = n(i[r]);
                c[a].references--;
              }
              for (var o = l(e, t), s = 0; s < i.length; s++) {
                var d = n(i[s]);
                0 === c[d].references && (c[d].updater(), c.splice(d, 1));
              }
              i = o;
            }
          };
        };
      },
      945: function _(e, t, i) {
        e.exports = i(79)("./src/clipboard.js");
      },
      704: function _(e, t, i) {
        e.exports = i(79)("./src/core.js");
      },
      492: function _(e, t, i) {
        e.exports = i(79)("./src/engine.js");
      },
      181: function _(e, t, i) {
        e.exports = i(79)("./src/typing.js");
      },
      273: function _(e, t, i) {
        e.exports = i(79)("./src/ui.js");
      },
      254: function _(e, t, i) {
        e.exports = i(79)("./src/undo.js");
      },
      209: function _(e, t, i) {
        e.exports = i(79)("./src/utils.js");
      },
      995: function _(e, t, i) {
        e.exports = i(79)("./src/widget.js");
      },
      79: function _(e) {
        "use strict";

        e.exports = CKEditor5.dll;
      }
    },
    t = {};
  function i(r) {
    var a = t[r];
    if (void 0 !== a) return a.exports;
    var o = t[r] = {
      id: r,
      exports: {}
    };
    return e[r](o, o.exports, i), o.exports;
  }
  i.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return i.d(t, {
      a: t
    }), t;
  }, i.d = function (e, t) {
    for (var r in t) i.o(t, r) && !i.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, i.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, i.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var r = {};
  (function () {
    "use strict";

    i.r(r), i.d(r, {
      AutoMediaEmbed: function AutoMediaEmbed() {
        return T;
      },
      MediaEmbed: function MediaEmbed() {
        return S;
      },
      MediaEmbedEditing: function MediaEmbedEditing() {
        return I;
      },
      MediaEmbedToolbar: function MediaEmbedToolbar() {
        return E;
      },
      MediaEmbedUI: function MediaEmbedUI() {
        return x;
      }
    });
    var e = i(704),
      t = i(995),
      a = i(209);
    function o(e, t) {
      return function (e) {
        e.on("attribute:url:media", i);
      };
      function i(i, r, a) {
        if (!a.consumable.consume(r.item, i.name)) return;
        var o = r.attributeNewValue,
          c = a.writer,
          n = a.mapper.toViewElement(r.item),
          l = _toConsumableArray(n.getChildren()).find(function (e) {
            return e.getCustomProperty("media-content");
          });
        c.remove(l);
        var s = e.getMediaViewElement(c, o, t);
        c.insert(c.createPositionAt(n, 0), s);
      }
    }
    function c(e) {
      var i = e.getSelectedElement();
      return i && function (e) {
        return !!e.getCustomProperty("media") && (0, t.isWidget)(e);
      }(i) ? i : null;
    }
    function n(e, t, i, r) {
      return e.createContainerElement("figure", {
        class: "media"
      }, [t.getMediaViewElement(e, i, r), e.createSlot()]);
    }
    function l(e) {
      var t = e.getSelectedElement();
      return t && t.is("element", "media") ? t : null;
    }
    function s(e, t, i) {
      e.change(function (r) {
        var a = r.createElement("media", {
          url: t
        });
        e.insertContent(a, i), r.setSelection(a, "on");
      });
    }
    var d = /*#__PURE__*/function (_e$Command) {
      _inherits(d, _e$Command);
      function d() {
        _classCallCheck(this, d);
        return _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments));
      }
      _createClass(d, [{
        key: "refresh",
        value: function refresh() {
          var e = this.editor.model,
            i = e.document.selection,
            r = l(i);
          this.value = r ? r.getAttribute("url") : null, this.isEnabled = function (e) {
            var t = e.getSelectedElement();
            return !!t && "media" === t.name;
          }(i) || function (e, i) {
            var r = (0, t.findOptimalInsertionRange)(e, i).start.parent;
            r.isEmpty && !i.schema.isLimit(r) && (r = r.parent);
            return i.schema.checkChild(r, "media");
          }(i, e);
        }
      }, {
        key: "execute",
        value: function execute(e) {
          var i = this.editor.model,
            r = i.document.selection,
            a = l(r);
          a ? i.change(function (t) {
            t.setAttribute("url", e, a);
          }) : s(i, e, (0, t.findOptimalInsertionRange)(r, i));
        }
      }]);
      return d;
    }(e.Command);
    var u = i(273);
    var m = /*#__PURE__*/function () {
      function m(e, t) {
        _classCallCheck(this, m);
        var i = t.providers,
          r = t.extraProviders || [],
          o = new Set(t.removeProviders),
          c = i.concat(r).filter(function (e) {
            var t = e.name;
            return t ? !o.has(t) : ((0, a.logWarning)("media-embed-no-provider-name", {
              provider: e
            }), !1);
          });
        this.locale = e, this.providerDefinitions = c;
      }
      _createClass(m, [{
        key: "hasMedia",
        value: function hasMedia(e) {
          return !!this._getMedia(e);
        }
      }, {
        key: "getMediaViewElement",
        value: function getMediaViewElement(e, t, i) {
          return this._getMedia(t).getViewElement(e, i);
        }
      }, {
        key: "_getMedia",
        value: function _getMedia(e) {
          if (!e) return new M(this.locale);
          e = e.trim();
          var _iterator = _createForOfIteratorHelper(this.providerDefinitions),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _t = _step.value;
              var _i = _t.html,
                _r = (0, a.toArray)(_t.url);
              var _iterator2 = _createForOfIteratorHelper(_r),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _t2 = _step2.value;
                  var _r2 = this._getUrlMatches(e, _t2);
                  if (_r2) return new M(this.locale, e, _r2, _i);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return null;
        }
      }, {
        key: "_getUrlMatches",
        value: function _getUrlMatches(e, t) {
          var i = e.match(t);
          if (i) return i;
          var r = e.replace(/^https?:\/\//, "");
          return i = r.match(t), i || (r = r.replace(/^www\./, ""), i = r.match(t), i || null);
        }
      }]);
      return m;
    }();
    var M = /*#__PURE__*/function () {
      function M(e, t, i, r) {
        _classCallCheck(this, M);
        this.url = this._getValidUrl(t), this._t = e.t, this._match = i, this._previewRenderer = r;
      }
      _createClass(M, [{
        key: "getViewElement",
        value: function getViewElement(e, t) {
          var i = {};
          var r;
          if (t.renderForEditingView || t.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (i["data-oembed-url"] = this.url), t.renderForEditingView && (i.class = "ck-media__wrapper");
            var _a = this._getPreviewHtml(t);
            r = e.createRawElement("div", i, function (e, t) {
              t.setContentOf(e, _a);
            });
          } else this.url && (i.url = this.url), r = e.createEmptyElement(t.elementName, i);
          return e.setCustomProperty("media-content", !0, r), r;
        }
      }, {
        key: "_getPreviewHtml",
        value: function _getPreviewHtml(e) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && e.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
      }, {
        key: "_getPlaceholderHtml",
        value: function _getPlaceholderHtml() {
          var e = new u.TooltipView(),
            t = new u.IconView();
          e.text = this._t("Open media in new tab"), t.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', t.viewBox = "0 0 64 42";
          return new u.Template({
            tag: "div",
            attributes: {
              class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [{
              tag: "div",
              attributes: {
                class: "ck-media__placeholder__icon"
              },
              children: [t]
            }, {
              tag: "a",
              attributes: {
                class: "ck-media__placeholder__url",
                target: "_blank",
                rel: "noopener noreferrer",
                href: this.url
              },
              children: [{
                tag: "span",
                attributes: {
                  class: "ck-media__placeholder__url__text"
                },
                children: [this.url]
              }, e]
            }]
          }).render().outerHTML;
        }
      }, {
        key: "_getValidUrl",
        value: function _getValidUrl(e) {
          return e ? e.match(/^https?/) ? e : "https://" + e : null;
        }
      }]);
      return M;
    }();
    var g = i(62),
      N = i.n(g),
      j = i(721),
      p = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    N()(j.Z, p);
    j.Z.locals;
    var I = /*#__PURE__*/function (_e$Plugin) {
      _inherits(I, _e$Plugin);
      _createClass(I, null, [{
        key: "pluginName",
        get: function get() {
          return "MediaEmbedEditing";
        }
      }]);
      function I(e) {
        var _this;
        _classCallCheck(this, I);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(I).call(this, e)), e.config.define("mediaEmbed", {
          elementName: "oembed",
          providers: [{
            name: "dailymotion",
            url: /^dailymotion\.com\/video\/(\w+)/,
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; \"><iframe src=\"https://www.dailymotion.com/embed/video/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" width=\"480\" height=\"270\" allowfullscreen allow=\"autoplay\"></iframe></div>");
            }
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;\"><iframe src=\"https://open.spotify.com/embed/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allowtransparency=\"true\" allow=\"encrypted-media\"></iframe></div>");
            }
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://www.youtube.com/embed/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe></div>");
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: function html(e) {
              return "<div style=\"position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;\"><iframe src=\"https://player.vimeo.com/video/".concat(e[1], "\" style=\"position: absolute; width: 100%; height: 100%; top: 0; left: 0;\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>");
            }
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), _this.registry = new m(e.locale, e.config.get("mediaEmbed"));
        return _this;
      }
      _createClass(I, [{
        key: "init",
        value: function init() {
          var e = this.editor,
            i = e.model.schema,
            r = e.t,
            c = e.conversion,
            l = e.config.get("mediaEmbed.previewsInData"),
            s = e.config.get("mediaEmbed.elementName"),
            u = this.registry;
          e.commands.add("mediaEmbed", new d(e)), i.register("media", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["url"]
          }), c.for("dataDowncast").elementToStructure({
            model: "media",
            view: function view(e, _ref) {
              var t = _ref.writer;
              var i = e.getAttribute("url");
              return n(t, u, i, {
                elementName: s,
                renderMediaPreview: i && l
              });
            }
          }), c.for("dataDowncast").add(o(u, {
            elementName: s,
            renderMediaPreview: l
          })), c.for("editingDowncast").elementToStructure({
            model: "media",
            view: function view(e, _ref2) {
              var i = _ref2.writer;
              var a = e.getAttribute("url");
              return function (e, i, r) {
                return i.setCustomProperty("media", !0, e), (0, t.toWidget)(e, i, {
                  label: r
                });
              }(n(i, u, a, {
                elementName: s,
                renderForEditingView: !0
              }), i, r("media widget"));
            }
          }), c.for("editingDowncast").add(o(u, {
            elementName: s,
            renderForEditingView: !0
          })), c.for("upcast").elementToElement({
            view: function view(e) {
              return ["oembed", s].includes(e.name) && e.getAttribute("url") ? {
                name: !0
              } : null;
            },
            model: function model(e, _ref3) {
              var t = _ref3.writer;
              var i = e.getAttribute("url");
              if (u.hasMedia(i)) return t.createElement("media", {
                url: i
              });
            }
          }).elementToElement({
            view: {
              name: "div",
              attributes: {
                "data-oembed-url": !0
              }
            },
            model: function model(e, _ref4) {
              var t = _ref4.writer;
              var i = e.getAttribute("data-oembed-url");
              if (u.hasMedia(i)) return t.createElement("media", {
                url: i
              });
            }
          }).add(function (e) {
            e.on("element:figure", function (e, t, i) {
              if (!i.consumable.consume(t.viewItem, {
                name: !0,
                classes: "media"
              })) return;
              var _i$convertChildren = i.convertChildren(t.viewItem, t.modelCursor),
                r = _i$convertChildren.modelRange,
                o = _i$convertChildren.modelCursor;
              t.modelRange = r, t.modelCursor = o;
              (0, a.first)(r.getItems()) || i.consumable.revert(t.viewItem, {
                name: !0,
                classes: "media"
              });
            });
          });
        }
      }]);
      return I;
    }(e.Plugin);
    var h = i(492),
      L = i(945),
      y = i(181),
      w = i(254);
    var k = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
    var T = /*#__PURE__*/function (_e$Plugin2) {
      _inherits(T, _e$Plugin2);
      _createClass(T, null, [{
        key: "requires",
        get: function get() {
          return [L.Clipboard, y.Delete, w.Undo];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "AutoMediaEmbed";
        }
      }]);
      function T(e) {
        var _this2;
        _classCallCheck(this, T);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(T).call(this, e)), _this2._timeoutId = null, _this2._positionToInsert = null;
        return _this2;
      }
      _createClass(T, [{
        key: "init",
        value: function init() {
          var _this3 = this;
          var e = this.editor,
            t = e.model.document;
          this.listenTo(e.plugins.get("ClipboardPipeline"), "inputTransformation", function () {
            var e = t.selection.getFirstRange(),
              i = h.LivePosition.fromPosition(e.start);
            i.stickiness = "toPrevious";
            var r = h.LivePosition.fromPosition(e.end);
            r.stickiness = "toNext", t.once("change:data", function () {
              _this3._embedMediaBetweenPositions(i, r), i.detach(), r.detach();
            }, {
              priority: "high"
            });
          }), e.commands.get("undo").on("execute", function () {
            _this3._timeoutId && (a.global.window.clearTimeout(_this3._timeoutId), _this3._positionToInsert.detach(), _this3._timeoutId = null, _this3._positionToInsert = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_embedMediaBetweenPositions",
        value: function _embedMediaBetweenPositions(e, t) {
          var _this4 = this;
          var i = this.editor,
            r = i.plugins.get(I).registry,
            o = new h.LiveRange(e, t),
            c = o.getWalker({
              ignoreElementEnd: !0
            });
          var n = "";
          var _iterator3 = _createForOfIteratorHelper(c),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _e = _step3.value;
              _e.item.is("$textProxy") && (n += _e.item.data);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          if (n = n.trim(), !n.match(k)) return void o.detach();
          if (!r.hasMedia(n)) return void o.detach();
          i.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = h.LivePosition.fromPosition(e), this._timeoutId = a.global.window.setTimeout(function () {
            i.model.change(function (e) {
              var t;
              _this4._timeoutId = null, e.remove(o), o.detach(), "$graveyard" !== _this4._positionToInsert.root.rootName && (t = _this4._positionToInsert), s(i.model, n, t), _this4._positionToInsert.detach(), _this4._positionToInsert = null;
            }), i.plugins.get("Delete").requestUndoOnBackspace();
          }, 100)) : o.detach();
        }
      }]);
      return T;
    }(e.Plugin);
    var D = i(764),
      _ = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    N()(D.Z, _);
    D.Z.locals;
    var b = i(961),
      z = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    N()(b.Z, z);
    b.Z.locals;
    var v = /*#__PURE__*/function (_u$View) {
      _inherits(v, _u$View);
      function v(t, i) {
        var _this5;
        _classCallCheck(this, v);
        _this5 = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this, i));
        var r = i.t;
        _this5.focusTracker = new a.FocusTracker(), _this5.keystrokes = new a.KeystrokeHandler(), _this5.set("mediaURLInputValue", ""), _this5.urlInputView = _this5._createUrlInput(), _this5.saveButtonView = _this5._createButton(r("Save"), e.icons.check, "ck-button-save"), _this5.saveButtonView.type = "submit", _this5.saveButtonView.bind("isEnabled").to(_assertThisInitialized(_assertThisInitialized(_this5)), "mediaURLInputValue", function (e) {
          return !!e;
        }), _this5.cancelButtonView = _this5._createButton(r("Cancel"), e.icons.cancel, "ck-button-cancel", "cancel"), _this5._focusables = new u.ViewCollection(), _this5._focusCycler = new u.FocusCycler({
          focusables: _this5._focusables,
          focusTracker: _this5.focusTracker,
          keystrokeHandler: _this5.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this5._validators = t, _this5.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this5.urlInputView, _this5.saveButtonView, _this5.cancelButtonView]
        }), (0, u.injectCssTransitionDisabler)(_assertThisInitialized(_assertThisInitialized(_this5)));
        return _this5;
      }
      _createClass(v, [{
        key: "render",
        value: function render() {
          var _this6 = this;
          _superPropGet(v, "render", this, 3)([]), (0, u.submitHandler)({
            view: this
          });
          [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(function (e) {
            _this6._focusables.add(e), _this6.focusTracker.add(e.element);
          }), this.keystrokes.listenTo(this.element);
          var e = function e(_e2) {
            return _e2.stopPropagation();
          };
          this.keystrokes.set("arrowright", e), this.keystrokes.set("arrowleft", e), this.keystrokes.set("arrowup", e), this.keystrokes.set("arrowdown", e), this.listenTo(this.urlInputView.element, "selectstart", function (e, t) {
            t.stopPropagation();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _superPropGet(v, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "isValid",
        value: function isValid() {
          this.resetFormStatus();
          var _iterator4 = _createForOfIteratorHelper(this._validators),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _e3 = _step4.value;
              var _t3 = _e3(this);
              if (_t3) return this.urlInputView.errorText = _t3, !1;
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return !0;
        }
      }, {
        key: "resetFormStatus",
        value: function resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var _this7 = this;
          var e = this.locale.t,
            t = new u.LabeledFieldView(this.locale, u.createLabeledInputText),
            i = t.fieldView;
          return this._urlInputViewInfoDefault = e("Paste the media URL in the input."), this._urlInputViewInfoTip = e("Tip: Paste the URL into the content to embed faster."), t.label = e("Media URL"), t.infoText = this._urlInputViewInfoDefault, i.on("input", function () {
            t.infoText = i.element.value ? _this7._urlInputViewInfoTip : _this7._urlInputViewInfoDefault, _this7.mediaURLInputValue = i.element.value.trim();
          }), t;
        }
      }, {
        key: "_createButton",
        value: function _createButton(e, t, i, r) {
          var a = new u.ButtonView(this.locale);
          return a.set({
            label: e,
            icon: t,
            tooltip: !0
          }), a.extendTemplate({
            attributes: {
              class: i
            }
          }), r && a.delegate("execute").to(this, r), a;
        }
      }, {
        key: "url",
        get: function get() {
          return this.urlInputView.fieldView.element.value.trim();
        },
        set: function set(e) {
          this.urlInputView.fieldView.element.value = e.trim();
        }
      }]);
      return v;
    }(u.View);
    var x = /*#__PURE__*/function (_e$Plugin3) {
      _inherits(x, _e$Plugin3);
      function x() {
        _classCallCheck(this, x);
        return _possibleConstructorReturn(this, _getPrototypeOf(x).apply(this, arguments));
      }
      _createClass(x, [{
        key: "init",
        value: function init() {
          var _this8 = this;
          var e = this.editor,
            t = e.commands.get("mediaEmbed"),
            i = e.plugins.get(I).registry;
          e.ui.componentFactory.add("mediaEmbed", function (r) {
            var a = (0, u.createDropdown)(r),
              o = new v(function (e, t) {
                return [function (t) {
                  if (!t.url.length) return e("The URL must not be empty.");
                }, function (i) {
                  if (!t.hasMedia(i.url)) return e("This media URL is not supported.");
                }];
              }(e.t, i), e.locale);
            return _this8._setUpDropdown(a, o, t, e), _this8._setUpForm(a, o, t), a;
          });
        }
      }, {
        key: "_setUpDropdown",
        value: function _setUpDropdown(e, t, i) {
          var r = this.editor,
            a = r.t,
            o = e.buttonView;
          function c() {
            r.editing.view.focus(), e.isOpen = !1;
          }
          e.bind("isEnabled").to(i), e.panelView.children.add(t), o.set({
            label: a("Insert media"),
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>',
            tooltip: !0
          }), o.on("open", function () {
            t.disableCssTransitions(), t.url = i.value || "", t.urlInputView.fieldView.select(), t.focus(), t.enableCssTransitions();
          }, {
            priority: "low"
          }), e.on("submit", function () {
            t.isValid() && (r.execute("mediaEmbed", t.url), c());
          }), e.on("change:isOpen", function () {
            return t.resetFormStatus();
          }), e.on("cancel", function () {
            return c();
          });
        }
      }, {
        key: "_setUpForm",
        value: function _setUpForm(e, t, i) {
          t.delegate("submit", "cancel").to(e), t.urlInputView.bind("value").to(i, "value"), t.urlInputView.bind("isReadOnly").to(i, "isEnabled", function (e) {
            return !e;
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [I];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedUI";
        }
      }]);
      return x;
    }(e.Plugin);
    var f = i(461),
      A = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    N()(f.Z, A);
    f.Z.locals;
    var S = /*#__PURE__*/function (_e$Plugin4) {
      _inherits(S, _e$Plugin4);
      function S() {
        _classCallCheck(this, S);
        return _possibleConstructorReturn(this, _getPrototypeOf(S).apply(this, arguments));
      }
      _createClass(S, null, [{
        key: "requires",
        get: function get() {
          return [I, x, T, t.Widget];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbed";
        }
      }]);
      return S;
    }(e.Plugin);
    var E = /*#__PURE__*/function (_e$Plugin5) {
      _inherits(E, _e$Plugin5);
      function E() {
        _classCallCheck(this, E);
        return _possibleConstructorReturn(this, _getPrototypeOf(E).apply(this, arguments));
      }
      _createClass(E, [{
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor,
            i = e.t;
          e.plugins.get(t.WidgetToolbarRepository).register("mediaEmbed", {
            ariaLabel: i("Media toolbar"),
            items: e.config.get("mediaEmbed.toolbar") || [],
            getRelatedElement: c
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [t.WidgetToolbarRepository];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedToolbar";
        }
      }]);
      return E;
    }(e.Plugin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).mediaEmbed = r;
}();